export default "__VITE_ASSET__KeOIhfFr__"